(function () {
  const overlay = document.getElementById("handwrite-overlay-root");
  const layer = document.getElementById("handwrite-layer-root");

  if (!overlay || !layer) return;

  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const svg = overlay.querySelector("svg");
  if (!svg) return;

  // ---- Pencil tuning ----
  const smoothing = 0.10;
  const minDistance = 10;
  const idleMs = 90;
  const fadeMs = 650;
  const maxPoints = 140;
  const strokeWidth = 0.55;

  let drawing = false;
  let points = [];
  let pathEl = null;
  let last = null;
  let idleTimer = null;

  // Map pointer position to full viewport
  function toSvgPoint(clientX, clientY) {
    return {
      x: (clientX / window.innerWidth) * 1000,
      y: (clientY / window.innerHeight) * 1000
    };
  }

  function pointsToPath(pts) {
    if (pts.length < 2) return "";
    const s = Math.max(0, Math.min(0.25, smoothing));

    let d = `M ${pts[0].x.toFixed(1)} ${pts[0].y.toFixed(1)}`;

    for (let i = 1; i < pts.length; i++) {
      const p0 = pts[i - 1];
      const p1 = pts[i];

      const mx = (p0.x + p1.x) / 2;
      const my = (p0.y + p1.y) / 2;

      const cx = p0.x + (p1.x - p0.x) * s;
      const cy = p0.y + (p1.y - p0.y) * s;

      d += ` Q ${cx.toFixed(1)} ${cy.toFixed(1)} ${mx.toFixed(1)} ${my.toFixed(1)}`;
    }

    const end = pts[pts.length - 1];
    d += ` T ${end.x.toFixed(1)} ${end.y.toFixed(1)}`;
    return d;
  }

  function startStroke(p) {
    drawing = true;
    points = [p];

    pathEl = document.createElementNS("http://www.w3.org/2000/svg", "path");
    pathEl.classList.add("handwrite-stroke");
    pathEl.setAttribute("fill", "none");
    pathEl.setAttribute("stroke-width", strokeWidth);
    pathEl.setAttribute("d", `M ${p.x.toFixed(1)} ${p.y.toFixed(1)}`);

    layer.appendChild(pathEl);
  }

  function releaseStroke() {
    if (!pathEl) return;

    pathEl.style.animation = `handwriteFadeOut ${fadeMs}ms linear forwards`;

    const el = pathEl;
    pathEl = null;
    points = [];
    drawing = false;

    setTimeout(() => {
      if (el && el.parentNode) el.remove();
    }, fadeMs + 30);
  }

  function bumpIdleRelease() {
    clearTimeout(idleTimer);
    idleTimer = setTimeout(releaseStroke, idleMs);
  }

  function onMove(e) {
    const allowed =
      e.pointerType === "mouse" ||
      e.pointerType === "pen" ||
      e.pointerType === "touch";

    if (!allowed) return;
    if (typeof e.clientX !== "number" || typeof e.clientY !== "number") return;

    const p = toSvgPoint(e.clientX, e.clientY);

    if (!drawing || !pathEl) startStroke(p);

    if (last) {
      const dx = p.x - last.x;
      const dy = p.y - last.y;
      const distSvg = Math.sqrt(dx * dx + dy * dy);
      const distPxApprox = distSvg * (window.innerWidth / 1000);
      if (distPxApprox < minDistance) return;
    }

    points.push(p);
    if (points.length > maxPoints) points.shift();

    last = p;

    const d = pointsToPath(points);
    if (d && pathEl) pathEl.setAttribute("d", d);

    bumpIdleRelease();
  }

  function onLeave() {
    releaseStroke();
    last = null;
  }

  window.addEventListener("pointermove", onMove, { passive: true });
  window.addEventListener("blur", onLeave);
  window.addEventListener("pointerleave", onLeave);
  window.addEventListener("pointercancel", onLeave);
})();
